/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PutApiAccountDefaultSocietaMutationRequest,
  PutApiAccountDefaultSocietaMutationResponse,
} from '../models/PutApiAccountDefaultSocieta.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  putApiAccountDefaultSocietaMutationResponseSchema,
  putApiAccountDefaultSocietaMutationRequestSchema,
} from '../zod/putApiAccountDefaultSocietaSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const putApiAccountDefaultSocietaMutationKey = () =>
  [{ url: '/api/account/default-societa' }] as const;

export type PutApiAccountDefaultSocietaMutationKey = ReturnType<
  typeof putApiAccountDefaultSocietaMutationKey
>;

/**
 * {@link /api/account/default-societa}
 */
export async function putApiAccountDefaultSocieta(
  data: PutApiAccountDefaultSocietaMutationRequest,
  config: Partial<RequestConfig<PutApiAccountDefaultSocietaMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData =
    putApiAccountDefaultSocietaMutationRequestSchema.parse(data);
  const res = await request<
    PutApiAccountDefaultSocietaMutationResponse,
    ResponseErrorConfig<Error>,
    PutApiAccountDefaultSocietaMutationRequest
  >({
    method: 'PUT',
    url: `/api/account/default-societa`,
    data: requestData,
    ...requestConfig,
  });
  return putApiAccountDefaultSocietaMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/account/default-societa}
 */
export function usePutApiAccountDefaultSocieta<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiAccountDefaultSocietaMutationResponse,
      ResponseErrorConfig<Error>,
      { data: PutApiAccountDefaultSocietaMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiAccountDefaultSocietaMutationRequest>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiAccountDefaultSocietaMutationKey();

  return useMutation<
    PutApiAccountDefaultSocietaMutationResponse,
    ResponseErrorConfig<Error>,
    { data: PutApiAccountDefaultSocietaMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return putApiAccountDefaultSocieta(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
